import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getSupportInsightMetaConnections = {
  name: "getSupportInsightMetaConnections" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({ facebook: z.boolean(), instagram: z.boolean() }),
};
